import Vue from "vue"
Vue.filter("fixedNumber", (value, fractionDigits) => {
    return isNaN(value) ? '' : value.toFixed(fractionDigits)
})
Vue.filter("number", (value) => {
    return isNaN(value) ? '-' : value
})
